<template>
  <div>
    <!-- File key input -->
    <!--    TODO: Add :placeholder="$t('eds.selectKey')" after vuetify fix in 2.5v-->
    <v-file-input :value="fileKey"
                  @change="$emit('input', $event)"
                  :label="$t('eds.privateKey')"
                  persistent-placeholder
                  hide-details
                  outlined dense
                  prepend-icon=""
                  clearable
                  :show-size="1000"
                  :disabled="loading"
                  autocomplete="off"
                  class="clearable mb-8 ">

      <template #prepend-inner>
        <v-icon small class="pt-1 pr-2">md mdi-paperclip</v-icon>
      </template>

      <template #selection="{ text }">
        <v-chip label small color="primary">{{ text }}</v-chip>
      </template>
    </v-file-input>

    <!-- Key password input -->
    <v-text-field :value="password"
                  @input="$emit('update:password', $event)"
                  :label="$t('login.password')"
                  :placeholder="$t('eds.passwordPlaceholder')"
                  outlined dense
                  name="password"
                  type="password"
                  hide-details
                  :disabled="loading || !fileKey"
                  autocomplete="off"
                  @keyup.enter="$emit('sign')"
                  class="clearable mb-8"
                  clearable
                  >

      <template #prepend-inner>
        <v-icon small class="pt-1 pr-2">md mdi-lock-open</v-icon>
      </template>

    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'EdsFileKey',
  model: {
    prop: 'fileKey'
  },
  props: {
    fileKey: {
      type: [File, null]
    },
    password: {
      type: [String, null]
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
